import React from 'react'

export default function ContenedorDatosCards(props) {
    return (
        <div className="p-grid p-justify-center text-center">              
              {props.children}
        </div>
    )
}
